export const wrapper = { background: "#12141D", color: "#FAFAFA" };
